// category: -1 = Oculto, 0 = All, 1 = Desktop, 2 = Frontend, 3 = Backend, 4 = Mobile App
export default [
  {
    title: 'SimuLTI',
    url: '/simulti',
    description: 'SimuLTI is a Linear time-invariant systems (LTI systems) simulator. The software shows the behavior of various possible configurations within a second order system. The software was coded in Python and uses wxPython and wxGlade to build the graphical interface.',
    imageUrl: '/images/projects/simulti_capa.jpg',
    category: [0, 1],  // All, Desktop
    icons: ['FaPython']
  },
  {
    title: 'Checkers in Haskell',
    url: '/checkershaskell',
    description: 'Version of the game Checkers completely made in Haskell. The game deals with basic moves, invalid moves and if one of the players won. The game explores Haskell concepts such as List comprehension, Pattern matching and Guards.',
    imageUrl: '/images/projects/checkers_capa2.jpg',
    category: [0, 1],
    icons: ['DiHaskell']  
  },
  {
    title: 'Hotspot',
    url: '/hotspot',
    description: 'Hotspot system made in React. The backend was developed in Node.js and authentication is done via SMS.',
    imageUrl: '/images/projects/hotspot_capa.jpg',
    category: [0, 2],
    icons: ['FaReact', 'FaCss3Alt', 'FaNodeJs']
  },
  {
    title: 'This website!',
    url: '/mywebsite',
    description: 'Yes, this website was a work that I developed using React and Google\'s Material Design library. 100% responsive!',
    imageUrl: '/images/projects/website_capa.jpg',
    category: [0, 2],
    icons: ['FaReact']
  },
  {
    title: 'snmp-fiberhome',
    url: '/snmpfiberhome',
    description: 'NPM module developed to communicate with Fiberhome OLTs using the SNMP protocol. The module is capable of managing the OLT, Slots, Cards, Pon ports and ONUs by performing read and write functions directly in OLT. The module was developed using TDD and the tests used the Tape module.',
    imageUrl: '/images/projects/npm_capa.png',
    category: [0, 3],
    icons: ['FaNodeJs', 'FaNpm']
  },
  {
    title: 'swagger-autogen',
    url: '/swaggerautogen',
    description: 'NPM module developed to performs the automatic construction of the Swagger documentation. The module is able to identify the endpoints and automatically capture methods such as get, post, put, and so on, along with the path. In addition to the methods and the path, the module can also identify the parameters in the path, query, body and response status code. It is possible to add information such as: endpoint description, parameter description, defininitions, security, among others. It is also possible to ignore or disable the automatic capture of an endpoint (having to manually inform each information in this case). The module generates a .json file with the documentation in the swagger format.',
    imageUrl: '/images/projects/npm_capa2.png',
    category: [0, 3],
    icons: ['FaNodeJs', 'FaNpm']
  },
  {
    title: 'REST API v1 (using Express.js)',
    url: '/restapiv1',
    description: 'A REST API developed using the Express.js framework. The API contains: Communication via HTTP and HTTPS, communication with the MongoDB database, caching with Redis, JWT authentication + SHA-256, documentation with Swagger, endpoints management and metrics with Swagger-stats, files to the Docker, CORS control, route control, regex, testing endpoints using Jest, a simple CRUD, among others.',
    imageUrl: '/images/projects/reat_api_v1.jpg',
    category: [0, 3],
    icons: ['FaNodeJs', 'FaNpm', 'FaDocker']
  },
  {
    title: 'REST API v2 (using Express.js)',
    url: '/restapiv2',
    description: 'A REST API developed using the Express.js framework. The API contains: Communication via HTTP and HTTPS, communication with the MySQL database using ORM Sequelize, JWT authentication + SHA-256, documentation with Swagger, endpoints management and metrics with Swagger-stats, files to the Docker, CORS control, route control, testing endpoints using Jest, a simple CRUD, among others.',
    imageUrl: '/images/projects/reat_api_v2.jpg',
    category: [0, 3],
    icons: ['FaNodeJs', 'FaNpm', 'FaDocker']
  },
  {
    title: 'REST API (Spring Boot) + Front',
    url: '/springboot',
    description: 'A REST API developed using Spring Boot with JPA, Hibernate, Maven, TomCat, JUnit, H2 database, Swagger documentation and JWT authentication. The API represents a system for video rental store. The repository also contains a simple React front.',
    imageUrl: '/images/projects/springboot.png',
    category: [0, 3],
    icons: ['FaJava', 'FaReact']
  }
];
